<template>
  <v-btn id="google-login" depressed large block class="my-5" @click="googleLogin" >
    <v-avatar size="25" class="grey lighten-2 mr-3">
      <v-img :src="require('@/assets/auth/google-logo.png')" />
    </v-avatar>
    <span class="font-weight-black">Continue with Google</span>
  </v-btn>
</template>


<script>
import firebase from '@/firebase.config'
import { initialiseUser } from './common'

export default {
  name: 'GoogleAuth',
  props: ['userType', 'redirectRouteName'],
  methods: {
    async googleLogin() {
      const provider = new firebase.auth.GoogleAuthProvider()
      let cred = await firebase.auth().signInWithPopup(provider)  
      await initialiseUser(cred, 'GOOGLE', this.userType)

      this.$store.dispatch('hideDialog')
      this.$store.dispatch('storeSnackbarMessage', 'You have successfully logged in')
      if (this.redirectRouteName){
        this.$router.push({ name: this.redirectRouteName})
      }
    }
  }
}
</script>